(() => {
  const addCalendarDays = (start, days) => {
    const date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    date.setDate(date.getDate() + days);
    return date;
  };

  const formatRange = (minimumDays = 7, maximumDays = 10) => {
    const today = new Date();
    const formatter = new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
    return `${formatter.format(addCalendarDays(today, minimumDays))} – ${formatter.format(addCalendarDays(today, maximumDays))}`;
  };

  const hydrate = scope => {
    scope.querySelectorAll('[data-wrc-delivery]').forEach(element => {
      const minimumDays = Number(element.dataset.wrcMinDays || 7);
      const maximumDays = Number(element.dataset.wrcMaxDays || 10);
      const prefix = element.dataset.wrcPrefix;
      const text = prefix ? `${prefix} ${formatRange(minimumDays, maximumDays)}` : `Estimated delivery: ${formatRange(minimumDays, maximumDays)}`;
      const target = element.querySelector('span') || element;
      target.textContent = text;
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    hydrate(document);
    const observer = new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) hydrate(node.matches('[data-wrc-delivery]') ? node.parentElement : node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
  document.addEventListener('shopify:section:load', event => hydrate(event.target));
})();
